import { useSelector } from "react-redux";
import { CYLINDER_CHANGE_COLUMNS } from "../../utils/ComplaintsTables.config";
import ArrowSorting from "../../../../components/common/ArrowSorting";
import { formatDate } from "../../../../functions/dateTime/formatDate";
import { checkValue } from "../../../../functions/checkValue";

export const SiteCylinderChangeTable = () => {
  const sitesData = useSelector((state) => state.data.data);
  return (
    <div className="bg-white rounded-xl shadow-sm overflow-hidden mt-2">
      <div className="whitespace-nowrap h-[calc(100vh-15em)] max-lg:h-[calc(100vh-14em)] max-md:h-[calc(100vh-13em)] overflow-auto">
        <table className="w-full border border-b-0">
          {/* Header */}
          <thead className="bg-[#f4f6fc] text-blue-1 uppercase text-[14px] max-lg:text-[11px] sticky top-0 2xs:max-md:top-0 z-99">
            <tr>
              {CYLINDER_CHANGE_COLUMNS.map((c) => (
                <th key={c.title} className="text-left px-4 py-3">
                  <span className="flex items-center">
                    {c.title}{" "}
                    {c.sortArrow && sitesData.length > 1 && (
                      <ArrowSorting
                        sortBy={c.sortBy}
                        address={c.address}
                        arrowColor="#3a4faa"
                      />
                    )}
                  </span>
                </th>
              ))}
            </tr>
          </thead>
          {/* Body */}
          <tbody className="text-[14px] max-lg:text-xs">
            {sitesData.length > 0 ? (
              sitesData.map((s) => (
                <tr
                  key={s.id}
                  className="border-t hover:bg-gray-50 text-gray-800 [&_td]:p-3"
                >
                  <td>
                    {s.stationName}{" "}
                    <p className="text-[10px] text-gray-400 font-normal">
                      SITE ID-{s.stationId}
                    </p>
                  </td>
                  <td>{s.fieldTechnicianName}</td>
                  <td>{s.supervisorName}</td>
                  <td>{formatDate(s.complaintDate)}</td>
                  <td>{formatDate(s.dateOfComplainAttended)}</td>
                  <td>{s.workingCylinder}</td>
                  <td>{s.standbyCylinder}</td>
                  <td>{s.lastWorkingCylinder}</td>
                  <td>{s.lastStandbyCylinder}</td>
                  <td>{checkValue(s.doseSet)}</td>
                  <td>{s.dailySupplyHour ? s.dailySupplyHour / 100 : "-"}</td>
                </tr>
              ))
            ) : (
              <tr>
                <td
                  colSpan={CYLINDER_CHANGE_COLUMNS.length}
                  className="text-center py-6 text-gray-500"
                >
                  No match the current filter.
                </td>
              </tr>
            )}
          </tbody>
        </table>
      </div>
    </div>
  );
};
